import { CommonsEnvironment } from '@infodata-group/inf-commons';

export const environment: CommonsEnvironment = {
  production: true,
  env: 'preprod',

  api: {
    apiEndPoint: 'api/',
    settingsApi: 'auth/settings',
  },
  app: {
    appName: 'Rapport',
    appVersion: '1.2.1',
    appVersionDate: '31/05/2023',
    defaultRoute: '',
    appId: 'inTsJRNc-ndaT-pl5E-23sO-wYwKrFfegPJY',
    cache: 1,
  },
  auth: {
    loginUrl: 'api/auth/auth-default',
    logoutUrl: 'api/auth/logout',
    azure: {
      tenant: 'o365.infodata.lu',
      client: '1ab0c7d0-9cba-4569-ab50-cea719fc647c',
      redirectUri: 'https://preprod-rapport.integrix.lu/oauth2',
      api: 'auth/auth-azure',
    },
  },
  login: {
    loginRoute: 'login',
    resetRequest: 'auth/reset-request',
    resetPassword: 'auth/reset-password',
    defaultConnection: true,
  },
  portal: {
    api: 'auth/auth-portal',
    portalUri: 'https://preprod-portail.integrix.lu',
    userAppsApi: 'auth/portail-apps',
    loadPortalApps: true,
    imagesUri: 'https://portail.integrix.lu/notifications-email/visu/',
  },
  ui: {
    appLogoPath: 'https://assets.integrix.lu/img/logos/integrix-rapport.png',
    companyLogoPath: 'https://assets.integrix.lu/img/logos/infodata.svg',
    lockerBackgroundPath:
      'https://assets.integrix.lu/img/backgrounds/2025.webp',
  },
  changelog: {
    enable: true,
    endpoint:
      'https://changelogs.integrix.lu/api/versions?&WITH=product|=|WEB-RPJ',
    route: 'changelogs',
  },
  links: {
    ticket: 'https://preprod-ticket.integrix.lu',
  },
};
